import { render, staticRenderFns } from "./recepty.vue?vue&type=template&id=fe0945d8&scoped=true&"
import script from "./recepty.vue?vue&type=script&lang=js&"
export * from "./recepty.vue?vue&type=script&lang=js&"
import style0 from "./recepty.vue?vue&type=style&index=0&id=fe0945d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0945d8",
  null
  
)

export default component.exports